import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

import { isAdmin } from '@/hooks/use-is-admin'

export const Route = createFileRoute('/_private/admin')({
  component: Outlet,
  beforeLoad: () => {
    if (!isAdmin()) {
      throw redirect({
        to: '/dashboard',
        replace: true,
      })
    }
  },
})
